// import { isEmpty } from 'lodash'

export const isChatOpened = (state) => state.isOpened
export const chatActualUser = (state) => state.user



// WEBPACK FOOTER //
// ./src/domain/chat/store/getters.js